import { get, concat } from 'lodash';
import ProductListType from './ProductList.type';
import { pageSize } from '../../../../Components/helper';

const initialState = {
  rangePlanProduct: [],
  rangePlanProductInfo: [],
  rangePlanProductBom: [],
  filterSelectedData: {
    selectedYear: [],
    selectedSeason: [],
    selectedBrand: [],
    selectedSubBrand: [],
    selectedMonth: [],
    selectedProductType: [],
    selectedCat1: [],
    selectedCat2: [],
    selectedCat3: [],
    selectedCat4: [],
    selectedSupplier: [],
    selectedCompanyUser: [],
    selectedStatus: [],
    selectedDynamic: [],
    pageIndex: 1,
    pageSize,
    selectedCoo: [],
    selectedColorway: [],
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
    searchText: '',
  },
  trackingDates: [],
  customSectionsArr: [],
  systemMeasurement: [],
  category1: [],
  category2: [],
  category3: [],
  category4: [],
  productTypeList: [],
  supplierList: [],
  statusList: [],
  companyUsers: [],
  rangeplanTotalCount: 0,
  productGroups: [],
  rangePlanLogs: [],
  totalCount: 0,

  /** Range Plan Card View States */
  rangePlanCards: [],
  rangePlanCardDetail: null,
  rangePlanCardTotalCount: 0,
  rangePlanCardLoading: false,
  rangePlanCardFilter: {
    pageIndex: 1,
    pageSize,
  },
  customSectionData: {
    data: [],
    totalProducts: 0,
    totalCount: 0,
    loading: false,
    error: null,
    customSectionDetails: null,
  },
  allSectionColumns: [],

  /** BM-7639: per-columnId → { scopes: string[], values: {all?, active?, selected?}, loading } */
  columnTotals: {},
};

/** Patches a nested detail object onto an array item identified by _id and returns the array. */
function addDetail(array, search, detail, keyName) {
  const arrIndex = array.findIndex((item) => {
    return item._id === search._id;
  });
  array[arrIndex][keyName] = detail;
  return array;
}

/** Returns the appended array when paginating (isScrolled) or the fresh payload data otherwise. */
const setArrayByCase = (array, payload) => {
  if (get(payload, 'isScrolled')) {
    array = concat(array, payload.data);
    return array;
  }
  return payload.data;
};

/** Redux reducer for the Range Plan / Product List feature state. */
const ProductListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ProductListType.RANGEPLANPRODUCT:
    case ProductListType.UPDATE_PRODUCTLIST: {
      const updatedArry = setArrayByCase(state.rangePlanProduct, action.payload);
      return {
        ...state,
        rangePlanProduct: updatedArry || [],
        rangeplanTotalCount: action.payload.totalCount,
      };
    }
    case ProductListType.PRODUCT_TAB_LIST: {
      let copyState = state.rangePlanProduct ? [...state.rangePlanProduct] : [];
      copyState = addDetail(copyState, { _id: action?.payload?.params?.devOrderId }, action?.payload?.data, action?.payload?.key);
      return {
        ...state,
        rangePlanProduct: copyState,
      };
    }
    case ProductListType.SET_FILTERDATA:
      return {
        ...state,
        filterSelectedData: { ...state.filterSelectedData, ...action.payload },
      };
    case ProductListType.GET_SAMPLE_TRACKING_PRODUCT_LISTING:
      return {
        ...state,
        trackingDates: action.payload,
      };
    case ProductListType.SET_MEASUREMENT_SYSTEM_MASTER:
      return {
        ...state,
        systemMeasurement: action.payload,
      };
    case ProductListType.SET_CRITICAL_PATH_CUSTOM_SECTIONS:
      return {
        ...state,
        customSectionsArr: action.payload,
      };
    case ProductListType.PRODUCT_LIST_CATEGORY:
      return {
        ...state,
        [`category${action.payload.catType}`]: action.payload.data,
      };
    case ProductListType.PRODUCT_LIST_PRODUCT_TYPE:
      return {
        ...state,
        productTypeList: action.payload,
      };
    case ProductListType.PRODUCTLIST_FETCH_REFERENCE_SUPPLIER:
      return {
        ...state,
        supplierList: action.payload,
      };
    case ProductListType.PRODUCT_LIST_GET_ALL_PRODUCT_STATUS_MASTER:
      return {
        ...state,
        statusList: action.payload,
      };
    case ProductListType.PRODUCT_LIST_COMPANY_USERS:
      return {
        ...state,
        companyUsers: action.payload,
      };
    case ProductListType.PRODUCT_LIST_CUSTOM_ATTRIBUTE_LIST:
      return {
        ...state,
        customAttributes: action.payload,
      };
    case ProductListType.PRODUCT_GROUP:
      return {
        ...state,
        productGroups: action.payload,
      };
    case ProductListType.UPDATE_PRODUCT_LIST:
      return {
        ...state,
        rangePlanProduct: action.payload,
      };
    case ProductListType.RP_PRODUCT_INFORMATION:
      return {
        ...state,
        rangePlanProductInfo: action.payload,
      };
    case ProductListType.RP_PRODUCT_INFORMATION_UNMOUNT:
      return {
        ...state,
        rangePlanProductInfo: [],
      };
    case ProductListType.CLEAR_FILTER_SELECTED_DATA:
      return {
        ...state,
        filterSelectedData: {
          selectedYear: [],
          selectedSeason: [],
          selectedBrand: [],
          selectedSubBrand: [],
          selectedMonth: [],
          selectedProductType: [],
          selectedCat1: [],
          selectedCat2: [],
          selectedCat3: [],
          selectedCat4: [],
          selectedSupplier: [],
          selectedCompanyUser: [],
          selectedStatus: [],
          selectedDynamic: [],
          pageIndex: 1,
          pageSize,
          selectedCoo: [],
          selectedColorway: [],
          selectedLicensor: [],
          selectedLicense: [],
          selectedLikeness: [],
          searchText: '',
        },
      };
    case ProductListType.GET_RANGE_PLAN_LOGS:
      return {
        ...state,
        rangePlanLogs: [...state.rangePlanLogs, ...action.payload.logs],
        totalCount: action.payload.totalCount,
      };
    case ProductListType.CLEAR_LOGS_REDUCER:
      return {
        ...state,
        rangePlanLogs: [],
        totalCount: 0,
      };

    /** Range Plan Card View Cases */
    case ProductListType.SET_RANGE_PLAN_CARDS: {
      const updatedCards = setArrayByCase(state.rangePlanCards, action.payload);
      return {
        ...state,
        rangePlanCards: updatedCards || [],
        rangePlanCardTotalCount: action.payload.totalCount || 0,
      };
    }
    case ProductListType.ADD_RANGE_PLAN_CARD:
      return {
        ...state,
        rangePlanCards: [action.payload, ...state.rangePlanCards],
        rangePlanCardTotalCount: state.rangePlanCardTotalCount + 1,
      };
    case ProductListType.UPDATE_RANGE_PLAN_CARD: {
      const updatedCards = state.rangePlanCards.map((card) => (card._id === action.payload._id ? { ...card, ...action.payload } : card));
      return {
        ...state,
        rangePlanCards: updatedCards,
        rangePlanCardDetail:
          state.rangePlanCardDetail?._id === action.payload._id ? { ...state.rangePlanCardDetail, ...action.payload } : state.rangePlanCardDetail,
      };
    }
    case ProductListType.DELETE_RANGE_PLAN_CARD: {
      const filteredCards = state.rangePlanCards.filter((card) => !action.payload.includes(card._id));
      return {
        ...state,
        rangePlanCards: filteredCards,
        rangePlanCardTotalCount: state.rangePlanCardTotalCount - action.payload.length,
      };
    }
    case ProductListType.DUPLICATE_RANGE_PLAN_CARD:
      return {
        ...state,
        rangePlanCards: [action.payload, ...state.rangePlanCards],
        rangePlanCardTotalCount: state.rangePlanCardTotalCount + 1,
      };
    case ProductListType.ARCHIVE_RANGE_PLAN_CARD: {
      const updatedCards = state.rangePlanCards.map((card) => (card._id === action.payload._id ? { ...card, ...action.payload } : card));
      return {
        ...state,
        rangePlanCards: updatedCards,
      };
    }
    case ProductListType.PIN_RANGE_PLAN_CARD: {
      const updatedCards = state.rangePlanCards.map((card) => (card._id === action.payload._id ? { ...card, pinned: action.payload.pinned } : card));
      return {
        ...state,
        rangePlanCards: updatedCards,
      };
    }
    case ProductListType.ACTIVE_INACTIVE_RANGE_PLAN_CARD: {
      const updatedCards = state.rangePlanCards.map((card) => (card._id === action.payload._id ? { ...card, isActive: action.payload.isActive } : card));
      return {
        ...state,
        rangePlanCards: updatedCards,
      };
    }
    case ProductListType.GET_RANGE_PLAN_CARD_DETAIL:
      return {
        ...state,
        rangePlanCardDetail: action.payload,
      };
    case ProductListType.CLEAR_RANGE_PLAN_CARD_DETAIL:
      return {
        ...state,
        rangePlanCardDetail: null,
      };
    case ProductListType.SET_RANGE_PLAN_CARD_LOADING:
      return {
        ...state,
        rangePlanCardLoading: action.payload,
      };
    case ProductListType.SET_RANGE_PLAN_CARD_FILTER:
      return {
        ...state,
        rangePlanCardFilter: { ...state.rangePlanCardFilter, ...action.payload },
      };
    case ProductListType.CLEAR_RANGE_PLAN_CARD_FILTER:
      return {
        ...state,
        rangePlanCardFilter: {
          selectedBrand: [],
          selectedSubBrand: [],
          selectedSeason: [],
          selectedYear: [],
          selectedMonth: [],
          selectedProductType: [],
          selectedCategory1: [],
          selectedCategory2: [],
          selectedStatus: [],
          selectedLicensor: [],
          selectedLicense: [],
          selectedLikeness: [],
          searchTerm: '',
          pageIndex: 1,
          pageSize,
          sortBy: 'createdAt',
          sortOrder: 'desc',
          isArchived: false,
        },
      };
    case ProductListType.CLEAR_RANGE_PLAN_CARDS:
      return {
        ...state,
        rangePlanCards: [],
        rangePlanCardTotalCount: 0,
        rangePlanCardLoading: true,
      };
    case ProductListType.GET_CUSTOM_SECTION_DATA:
      return {
        ...state,
        customSectionData: {
          data: action.payload.data || [],
          totalProducts: action.payload.totalProducts || 0,
          totalCount: action.payload.totalCount || 0,
          loading: false,
          error: null,
          customSectionDetails: action.payload.customSectionDetails || [],
        },
      };
    case ProductListType.GET_CUSTOM_SECTION_DATA_ERROR:
      return {
        ...state,
        customSectionData: {
          ...state.customSectionData,
          data: [],
          totalProducts: 0,
          totalCount: 0,
          loading: false,
          error: true,
          erroredSectionId: action.payload?.sectionId || null,
        },
      };
    case ProductListType.GET_ALL_SECTION_COLUMNS:
      return {
        ...state,
        allSectionColumns: action.payload || [],
      };

    /**
     * Replaces the ticked scope list for a column. Stale values for untick scopes are dropped
     * so old numbers don't linger.
     * @payload { columnId: string, scopes: string[] }
     */
    case ProductListType.TOGGLE_COLUMN_TOTAL_SCOPE: {
      const { columnId, scopes } = action.payload;
      const existing = state.columnTotals[columnId] || { scopes: [], values: {}, loading: false };
      const nextValues = {};
      for (const s of scopes) if (existing.values[s] !== undefined) nextValues[s] = existing.values[s];
      return {
        ...state,
        columnTotals: {
          ...state.columnTotals,
          [columnId]: { ...existing, scopes, values: nextValues },
        },
      };
    }

    /**
     * Sets the loading flag on one or more column totals entries.
     * @payload { columnIds: string[], loading: boolean }
     */
    case ProductListType.SET_COLUMN_TOTALS_LOADING: {
      const { columnIds = [], loading } = action.payload;
      const next = { ...state.columnTotals };
      for (const id of columnIds) {
        next[id] = { ...(next[id] || { scopes: [], values: {} }), loading };
      }
      return { ...state, columnTotals: next };
    }

    /**
     * Merges server-supplied totals into the per-column entry. Merge (not replace) so a partial
     * response (e.g. one-scope refetch) doesn't blow away other scope values.
     * @payload { totals: { [columnId]: { all?: number, active?: number, selected?: number } } }
     */
    case ProductListType.SET_COLUMN_TOTALS_SUCCESS: {
      const { totals = {} } = action.payload;
      const next = { ...state.columnTotals };
      for (const [columnId, scopeValues] of Object.entries(totals)) {
        const existing = next[columnId] || { scopes: [], values: {}, loading: false };
        next[columnId] = {
          ...existing,
          values: { ...existing.values, ...scopeValues },
          loading: false,
        };
      }
      return { ...state, columnTotals: next };
    }

    /**
     * Applies an incremental delta to the 'all' scope total after an inline cell edit. Only the
     * 'all' scope is server-supplied; 'active' / 'selected' are derived client-side from
     * localTableData / selection and update themselves.
     * @payload { columnId: string, delta: number }
     */
    case ProductListType.APPLY_COLUMN_TOTAL_DELTA: {
      const { columnId, delta } = action.payload;
      const existing = state.columnTotals[columnId];
      if (!existing || !existing.scopes || existing.scopes.length === 0) return state;
      if (!Number.isFinite(delta) || delta === 0) return state;
      if (!existing.scopes.includes('all') || typeof existing.values?.all !== 'number') return state;
      return {
        ...state,
        columnTotals: {
          ...state.columnTotals,
          [columnId]: {
            ...existing,
            values: { ...existing.values, all: existing.values.all + delta },
          },
        },
      };
    }

    default:
      return state;
  }
};

export default ProductListReducer;
